import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_DRIVER} from '../../metamodel/Concept';

export default class DriverNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_DRIVER;
	}
}
